<template>
<div class="common-flexbox flex-direction-column register registerContainer">
    <VeeForm class="form-container">
        <div v-if="canBypassReg" class="heading form-fields-heading">{{$t('register.new_reg_title_with_bypass')}}</div>
        <div v-else class="heading form-fields-heading align-left">{{$t(`register.${title}`)}}</div>
        <div class="container" v-if="!canBypassReg">
            <div class="input-container inputbox-container marginbt16">
                <InputBox type="text" class="email-input" :label="$t('register.company_email')" :data-vv-as="$t('register.company_email')" id="companyEmail" name="companyEmail" :disabledVal="true" :regFlowLogin="true" autocomplete="off" :modelValue="participant.companyEmail.value" v-model="participant.companyEmail.value" />
            </div>
            <div class="input-container inputbox-container marginbt16">
                <InputBox v-if="isMissingInformation.IsMissingFields && isMissingInformation.NoCompany === undefined" id="companyName" class="email-input" type="text" :label="$t('register.company')" :data-vv-as="$t('register.company')" name="company" autocomplete="off" :regFlowLogin="true" :modelValue="participant.company.value" :rules="participant.company.rules" v-model="participant.company.value" :disabledVal="isMissingInformation.IsMissingFields && isMissingInformation.NoCompany === undefined" :autofocusVal="participant.company.autofocus" />
                <VeeField v-else name="companyName" :rules="participant.company.rules" v-slot="{ field, errors }">
                    <AutoComplete
                      :field="field"
                      id="companyName"
                      :suggestions="participant.company.filteredOptions"
                      @onSelected="onCompanySelected"
                      :limit="participant.company.limit"
                      :label="$t('register.company')"
                      :input-props="participant.company.inputProps"
                      @blur="onCompanySelected"
                      @update:modelValue="onCompanyInputChange"
                      name="company"
                      :regFlowLogin="true"
                      v-model="participant.company.value"
                      :rules="participant.company.rules"
                    />
                    <div v-if="errors.length" class="align-left error-message">{{ getErrorMessage($t('register.company'), errors[0]) }}</div>
                </VeeField>
            </div>
        </div>
        <div class="container" v-if="!canBypassReg">
            <div class="input-container inputbox-container marginbt16">
                <VeeField name="firstName" :rules="participant.firstName.rules" v-slot="{ field, errors }">
                    <InputBox :field="field" type="text" class="email-input" :label="$t('register.first_name')" id="firstName" name="firstName" :data-vv-as="$t('register.first_name')" :modelValue="participant.firstName.value" v-model="participant.firstName.value" :rules="participant.firstName.rules" :disabledVal="isMissingInformation.IsMissingFields && isMissingInformation.NoFirstName === undefined" max-length="50" :regFlowLogin="true" @update="handleFirstNameChange" :autofocusVal="participant.firstName.autofocus" />
                    <div v-if="errors.length" class="align-left error-message">{{ getErrorMessage($t('register.first_name'), errors[0]) }}</div>
                </VeeField>
            </div>
            <div class="input-container inputbox-container marginbt16">
                <VeeField name="lastName" :rules="participant.lastName.rules" v-slot="{ field, errors }">
                    <InputBox :field="field" class="email-input" id="lastName" name="lastName" :data-vv-as="$t('register.last_name')" type="text" :label="$t('register.last_name')" autocomplete="off" :modelValue="participant.lastName.value" v-model="participant.lastName.value" :rules="participant.lastName.rules" :disabledVal="isMissingInformation.IsMissingFields && isMissingInformation.NoLastName === undefined" max-length="50" :regFlowLogin="true" @update="handleLastNameChange" :autofocusVal="participant.lastName.autofocus" />
                    <div v-if="errors.length" class="align-left error-message">{{ getErrorMessage($t('register.last_name'), errors[0]) }}</div>
                </VeeField>
            </div>
        </div>
        <div class="container" v-if="!canBypassReg">
            <div class="input-container inputbox-container marginbt16" :class="{'width-100' : !requirePhoneNumber}">

                <InputBox v-if="isMissingInformation.IsMissingFields && isMissingInformation.NoCountry === undefined" type="text" class="email-input" :label="$t('register.country')" :data-vv-as="$t('register.country')" name="country" autocomplete="off" :regFlowLogin="true" :rules="participant.country.rules" :modelValue="participant.country.value.Name" v-model="participant.country.value.Name" :disabledVal="isMissingInformation.IsMissingFields && isMissingInformation.NoCountry === undefined" :autofocusVal="participant.country.autofocus" />
                <VeeField name="country" :rules="participant.country.rules" v-slot="{ field, errors }" v-else>
                    <SearchDropdown :options="countries" :field="field" :elementId="'countriesDropdown'" :selectedItem="participant.country.value" :enableCenteredSelection="true" name="country" :searchRegex="'^'" :rules="participant.country.rules" :data-vv-as="$t('register.country')" :placeholder="$t('register.country')" v-model="participant.country.value" @selectedItem="onCountrySelected">
                    </SearchDropdown>
                    <div v-if="errors.length" class="align-left error-message">{{ getErrorMessage($t('register.country'), errors[0]) }}</div>
                </VeeField>
            </div>
            <div class="input-container inputbox-container marginbt16" v-if="requirePhoneNumber">

                <VeeField name="companyPhoneNumber" :rules="phoneValidationRule" v-slot="{ field, errors }">
                    <InputBox :field="field" type="text" class="email-input" id="companyPhone" name="companyPhoneNumber" :label="$t('register.company_phone')" :data-vv-as="$t('register.company_phone')" autocomplete="off" :regFlowLogin="true" :modelValue="participant.phoneNumber.value" v-model="participant.phoneNumber.value" :disabledVal="isMissingInformation.IsMissingFields && isMissingInformation.NoPhoneNumber === undefined" :rules="phoneValidationRule" @update="handlePhoneChange" :autofocusVal="participant.phoneNumber.autofocus" @blur="handlePhoneBlur" />

                    <div v-if="errors.length && participant.phoneNumber.hasBlurred" class="align-left error-message">{{ getErrorMessage($t('register.company_phone'), errors[0]) }}</div>
                </VeeField>
            </div>
        </div>
        <div class="container" v-if="!canBypassReg && hasAccountType">
            <div class="input-container inputbox-container marginbt16">
                <InputBox v-if="isMissingInformation.IsMissingFields && isMissingInformation.NoAccountType === undefined" type="text" class="email-input" :label="$t('register.account_type')" :data-vv-as="$t('register.account_type')" name="accountType" :regFlowLogin="true" autocomplete="off" :rules="participant.accountType.rules" :modelValue="participant.accountType.value.Title" v-model="participant.accountType.value.Title" :disabledVal="isMissingInformation.IsMissingFields && isMissingInformation.NoAccountType === undefined" :autofocusVal="participant.accountType.autofocus" />
                <CustomDropDown v-else class="drop-down" :modelValue="participant.accountType.value" :options="accountTypes" optionKey="Id" :regFlowLogin="true" optionValue="Title" :placeHolderValue="$t('register.account_type')" name="accountType" :rules="participant.accountType.rules" :data-vv-as="$t('register.account_type')" @change="onAccountTypeChange" id="accountType" />
            </div>
            <div class="input-container inputbox-container marginbt16">
                <InputBox v-if="isMissingInformation.IsMissingFields && isMissingInformation.NoAccountType === undefined" type="text" class="email-input" :label="$t('register.company_role')" :data-vv-as="$t('register.company_role')" name="companyRole" :regFlowLogin="true" autocomplete="off" :rules="participant.companyRole.rules" :modelValue="participant.companyRole.value.Title" v-model="participant.companyRole.value.Title" :disabledVal="isMissingInformation.IsMissingFields && isMissingInformation.NoAccountType === undefined" :autofocusVal="participant.companyRole.autofocus" />
                <CustomDropDown v-else :modelValue="participant.companyRole.value" :options="companyRoles" optionKey="Id" optionValue="Title" :placeHolderValue="$t('register.company_role')" name="companyRole" :regFlowLogin="true" :rules="participant.companyRole.rules" :data-vv-as="$t('register.company_role')" :maxHeight="160" :disabledVal="!participant.accountType.value" :resetVal="!companyRoles.length" id="companyRole" @change="onCompanyRoleChange" />

            </div>
        </div>
        <span class="pp-tos-header">
            <input id="privacyPolicyAgreementCheckBox" type="checkbox" class="consent-checkbox" v-model="consentForPolicyAndTerms" name="consentBool" />
            <label class="consent-label" v-html="$t('register.privacy_policy_and_tos', { url: privacyPolicyLink(), tosUrl: termsOfServiceLink() })">
            </label>
        </span>
        <div class="common-flexbox button-container">
            <button type="button" class="common-button" id="registerContinueButton" :class="{ disable: !consentForPolicyAndTerms || !isComplete }" :disabled="!consentForPolicyAndTerms || !isComplete" @click.prevent="onSubmit()">{{$t('login.continue')}}</button>
        </div>
    </VeeForm>
</div>
</template>

<script setup>
import { ref, reactive, computed, watch, onMounted, onBeforeMount } from 'vue';
import { useI18n } from 'vue-i18n';

import Constants from '@/utils/constants';
import { InputBox } from '@/components/ui/Form';
import AutoComplete from '@/components/common/AutoComplete';
import CustomDropDown from '@/components/common/CustomDropDown/MaterialCustomDropDown.vue';
import {
    isNullUndefined,
    privacyPolicyLink,
    termsOfServiceLink
} from "@/utils/helper.js";
import SearchDropdown from '@/components/common/SearchDropdown.vue';

// Import composables
import { 
    useLogin, 
    useConferenceCall, 
    useRouting, 
    useGlobal,
    useCorporateBranding,
    useEmailValidation 
} from '@/composables';

// For accessing route params
import { useRoute } from 'vue-router';

// Define component name
defineOptions({
    name: 'register'
});

// Composables
const { t, locale } = useI18n();

// Initialize composables
const {
    userEmailAddress: emailAddress,
    isRegisterPostSuccess,
    countries,
    isMissingInformation,
    isCompleteProfileSuccess,
    accountTypes,
    companyRoles: companyRolesData,
    companySuggestions,
    redirectTo,
    canBypassReg,
    saveNewUser,
    setEmailAddress,
    fetchCountries,
    fetchMissingInformationStatus,
    completeUserProfile,
    getRedirectAfterProfileCompletion,
    fetchAccountTypes,
    fetchCompanyRoles,
    fetchCompanySuggestions,
    savePrivacyPolicyConsent,
    fetchPresenterRegBypass,
} = useLogin();

const { displaySystemMessage } = useGlobal();

const {
    conferenceCallDetails: conferenceCall,
    isSlideLiveVideo,
    isSlideConf,
    isVideoWebinar,
    isConfOnly,
    showId,
    confId,
    uniqueId,
    isListenOnly,
} = useConferenceCall();

const { changeUrl } = useRouting();

// For accessing route parameters  
const route = useRoute();

const {
    brandingData: getBrandingInfo,
    hasAccountType,
    requirePhoneNumber,
} = useCorporateBranding();

// Reactive data
const participant = reactive({
    firstName: {
        value: '',
        rules: {
            required: true
        },
        autofocus: false
    },
    lastName: {
        value: '',
        rules: {
            required: true
        },
        autofocus: false
    },
    country: {
        value: null,
        rules: {
            required: true
        },
        autofocus: false
    },
    company: {
        value: '',
        rules: {
            required: true
        },
        autofocus: false,
        filteredOptions: [],
        inputProps: {
            id: 'autosuggest__input',
            disabled: false,
        },
        limit: 10
    },
    companyEmail: {
        value: route.params.email,
        rules: {
            required: true,
            regex: Constants.EmailAddressRegex
        }
    },
    phoneNumber: {
        value: '',
        autofocus: false,
        hasBlurred: false
    },
    accountType: {
        value: '',
        rules: {
            required: true,
        },
        autofocus: false,
    },
    companyRole: {
        value: '',
        rules: {
            required: true,
        },
        autofocus: false,
    },
});

const companyRoles = ref([]);
const isCompanyLoading = ref(false);
const consentForPolicyAndTerms = ref(false);

// Component-specific reactive data

// Component-specific computed properties

const isComplete = computed(() => {
     // Skip validation if registration can be bypassed
     if (canBypassReg.value) {
        return true;
    }

    // Check firstName
    const firstNameValid = !!participant.firstName.value;

    // Check lastName
    const lastNameValid = !!participant.lastName.value;

    // Check country
    const countryValid = !!participant.country.value;

    // Check company
    const companyValid = !!participant.company.value;

    // Check phone number (only if required) - masked values are considered valid
    const phoneIsValid = !requirePhoneNumber.value ||
        (!!participant.phoneNumber.value && 
         (participant.phoneNumber.value === Constants.MaskedValue || isPhoneValid(participant.phoneNumber.value)));

    // Check account type and role (only if required)
    const accountTypeValid = !hasAccountType.value ||
        (!!participant.accountType.value && !!participant.companyRole.value);

    // All fields must be valid
    return firstNameValid && lastNameValid && countryValid &&
        companyValid && phoneIsValid && accountTypeValid;
});

const title = computed(() => {
    return isMissingInformation.value.IsMissingFields ? Constants.RegisterPageHeading.onMissingInformation :
        Constants.RegisterPageHeading.onNewUserRegistration;
});

const phoneValidationRule = computed(() => {
    // Allow masked value to pass validation
    const maskedValueEscaped = Constants.MaskedValue.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const phoneRegexWithMasked = new RegExp(`^(${Constants.PhoneNumberRegex.source}|${maskedValueEscaped})$`);
    
    return {
        required: true,
        regex: phoneRegexWithMasked,
        PhoneMinMaxCustom: [6, 13]
    };
});

// Methods
const handleEmailChange = (value) => {
    participant.company.value = value;
};

const handleFirstNameChange = (value) => {
    participant.firstName.value = value;
};

const handleLastNameChange = (value) => {
    participant.lastName.value = value;
};

const handlePhoneChange = (value) => {
    participant.phoneNumber.value = value;

    // Clear errors when typing valid input
    if (value && isPhoneValid(value)) {
        // Reset hasBlurred if the value matches the phone regex
        if (value.match(Constants.PhoneNumberRegex)) {
            participant.phoneNumber.hasBlurred = false;
        }
    }
};

const isPhoneValid = (value) => {
    return Constants.PhoneNumberRegex.test(value) && value.length >= 6 && value.length <= 13;
};

const handlePhoneBlur = () => {
    // Set hasBlurred to true when the field loses focus
    participant.phoneNumber.hasBlurred = true;
};

const onSubmit = () => {
    if (!canBypassReg.value) {
        const show = uniqueId.value ? showId.value : route.query.show;
        const confIdValue = uniqueId.value ? confId.value : route.query.confId;
        let newUserParam = getUserParams(
            participant,
            show,
            confIdValue,
            consentForPolicyAndTerms.value,
            isListenOnly.value,
        );
        setEmailAddress(participant.companyEmail.value);
        if (isMissingInformation.value.IsMissingFields) {
            completeUserProfile(newUserParam);
        } else {
            saveNewUser(newUserParam);
        }
    } else {
        let consentData = {
            "UserName": emailAddress.value.toLowerCase(),
            "IsConsentingToPrivacyPolicy": consentForPolicyAndTerms.value,
        }
        savePrivacyPolicyConsent(consentData);
    }
};

const handleUserRedirection = async (newVal) => {
    if (isRegisterPostSuccess.value === 'Success') {
        if (conferenceCall.value.RequireVerification && !canBypassReg.value) {
            uniqueId.value ? changeUrl('validation-new') : changeUrl('validation');
        } else {
            var redirectUrl = await getRedirectAfterProfileCompletion();
            changeUrl(redirectUrl);
        }
    }
};

const getErrorMessage = (field, error) => {
    return t(error, {
        field: field
    });
};

const onCompanySelected = (option) => {
    // Handle different formats from different events
    if (option && option.item) {
        // From dropdown selection
        participant.company.value = option.item.Name;
    } else {
        // Fallback
        participant.company.value = option;
    }
};

const onCompanyInputChange = (text) => {
    let filteredData = [];
    if (!(text === '' || text === undefined)) {
        // Check if we have company suggestions
        if (Array.isArray(companySuggestions.value)) {
            filteredData = companySuggestions.value
                .filter(item => {
                    return item.Name && item.Name.toLowerCase().indexOf(text.toLowerCase()) > -1;
                })
                .slice(0, participant.company.limit);
        }
    }

    // Update filtered options
    participant.company.filteredOptions = filteredData;
};

const resetModelForMissingInformation = () => {
    if (isMissingInformation.value.IsMissingFields) {
        participant.companyEmail.value = emailAddress.value;
        participant.firstName.value = (isMissingInformation.value.IsMissingFields && !isNullUndefined(isMissingInformation.value.NoFirstName)) ? '' : Constants.MaskedValue;
        participant.lastName.value = (isMissingInformation.value.IsMissingFields && !isNullUndefined(isMissingInformation.value.NoLastName)) ? '' : Constants.MaskedValue;
        participant.company.value = (isMissingInformation.value.IsMissingFields && !isNullUndefined(isMissingInformation.value.NoCompany)) ? '' : Constants.MaskedValue;
        participant.phoneNumber.value = (isMissingInformation.value.IsMissingFields && !isNullUndefined(isMissingInformation.value.NoPhoneNumber)) ? '' : Constants.MaskedValue;
        participant.country.value = (isMissingInformation.value.IsMissingFields && !isNullUndefined(isMissingInformation.value.NoCountry)) ? null : {
            "Name": Constants.MaskedValue,
            "Id": 0
        };
        participant.accountType.value = (isMissingInformation.value.IsMissingFields && !isNullUndefined(isMissingInformation.value.NoAccountType)) ? '' : {
            "Title": Constants.MaskedValue,
            "Id": 0
        };
        participant.companyRole.value = (isMissingInformation.value.IsMissingFields && !isNullUndefined(isMissingInformation.value.NoAccountType)) ? '' : {
            "Title": Constants.MaskedValue,
            "Id": 0
        };
    }
};

const setAutofocus = () => {
    if (!isNullUndefined(emailAddress.value)) {
        if (isMissingInformation.value.IsMissingFields && !isNullUndefined(isMissingInformation.value.NoFirstName)) {
            participant.firstName.autofocus = true;
        } else if (isMissingInformation.value.IsMissingFields && !isNullUndefined(isMissingInformation.value.NoLastName)) {
            participant.lastName.autofocus = true;
        } else if (isMissingInformation.value.IsMissingFields && !isNullUndefined(isMissingInformation.value.NoCompany)) {
            participant.company.autofocus = true;
        } else if (isMissingInformation.value.IsMissingFields && !isNullUndefined(isMissingInformation.value.NoPhoneNumber)) {
            participant.phoneNumber.autofocus = true;
        } else if (isMissingInformation.value.IsMissingFields && !isNullUndefined(isMissingInformation.value.NoCountry)) {
            participant.country.autofocus = true;
        } else if (isMissingInformation.value.IsMissingFields && !isNullUndefined(isMissingInformation.value.NoAccountType)) {
            participant.country.autofocus = true;
        }
    }
};

const checkForMissingInformation = async () => {
    if (!redirectTo.value && (isMissingInformation.value.IsMissingFields === null || isMissingInformation.value.IsMissingFields === undefined)) {
        await fetchMissingInformationStatus(emailAddress.value);
    }
    resetModelForMissingInformation();
    setAutofocus();
};

const redirectUser = async () => {
    if (isCompleteProfileSuccess.value === 'Success') {
        var redirectUrl = await getRedirectAfterProfileCompletion();
        changeUrl(redirectUrl);
    };
};


const onAccountTypeChange = async (val) => {
    participant.accountType.value = val;
    if (isCompanyLoading.value) return;
    resetCompanyRolesProps(true, []);
    await fetchCompanyRoles({
        accountTypeId: val.Id
    });
    resetCompanyRolesProps(false, companyRolesData.value[val.Id]);
};

const resetCompanyRolesProps = (loading, roles) => {
    isCompanyLoading.value = loading;
    companyRoles.value = roles;
};

const onCompanyRoleChange = (val) => {
    participant.companyRole.value = val;
};

const onCountrySelected = (val) => {
    participant.country.value = val;
};

// Watchers
watch(isRegisterPostSuccess, (newVal, oldVal) => {
    handleUserRedirection(newVal);
});

watch(isCompleteProfileSuccess, (newVal, oldVal) => {
    redirectUser();
});

watch(locale, async (newValue, oldValue) => {
    console.log(newValue);
    if (newValue !== oldValue) {
        fetchCountries();
        await fetchAccountTypes();
        const accountType = accountTypes.value
            .filter(item => item.Id === participant.accountType.value.Id)[0]
        if (accountType) {
            participant.accountType.value = accountType;
        }
        if (participant.accountType.value) {
            await fetchCompanyRoles({
                accountTypeId: participant.accountType.value.Id,
                refreshOnLangChange: true
            });
            resetCompanyRolesProps(false, companyRolesData.value[participant.accountType.value.Id]);
            const companyRole = companyRoles.value
                .filter(item => item.Id === participant.companyRole.value.Id)[0]
            if (companyRole) {
                participant.companyRole.value = companyRole;
            }
        }
    }
});

// Lifecycle hooks
onBeforeMount(() => {
    participant.companyEmail.value = emailAddress.value;
    if (!canBypassReg.value) {
        checkForMissingInformation();
        fetchAccountTypes();
        fetchCountries();
        fetchCompanySuggestions(emailAddress.value);
    }
    if (sessionStorage.getItem(Constants.SessionStorageKeys.AccountConfirmed)) {
        sessionStorage.removeItem(Constants.SessionStorageKeys.AccountConfirmed);
        displaySystemMessage(Constants.Messages.AccountConfirmation);
    }
});

onMounted(async () => {
    if (canBypassReg.value === null && (isSlideLiveVideo.value || isSlideConf.value || isVideoWebinar.value || isConfOnly.value)) {
        await fetchPresenterRegBypass({
            presId: conferenceCall.value.PresId,
            emailAddress: emailAddress.value,
            confId: conferenceCall.value.Id
        });
    }
});

function getUserParams(participant, showLink, confId, consentForPolicyAndTerms, isListenOnly) {
    return {
        FirstName: participant.firstName.value,
        LastName: participant.lastName.value,
        EmailAddress: participant.companyEmail.value,
        Company: participant.company.value,
        PhoneNumber: participant.phoneNumber.value,
        ShowLink: showLink,
        CountryId: participant.country.value ? participant.country.value.Id : "",
        ConfId: confId ? parseInt(confId) : null,
        PrivacyPolicyAgreement: consentForPolicyAndTerms,
        AccountTypeId: participant.accountType.value.Id,
        CompanyRoleId: participant.companyRole.value.Id,
        ListenOnly: isListenOnly,
    };
}
</script>
    
<style lang="stylus" scoped>
@import '~@/shared/styles/common.scss';
@import '~@/shared/styles/formControl.scss';

.input-container {
    position: relative;
}

.form-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    flex: 1;
}

.pad-right {
    padding-right: 20px;
}

.auto-suggest-container div {
    width: 100%;
}

.register :deep(.container-autocomplete) {
    z-index: auto;

    .pt-10 {
        z-index: auto;
    }

    .multiselect--active {
        z-index: auto;
    }
}

.block-level {
    display: block;
}

.pp-tos-header {
    text-align: left;
    width: 100%;
    font-size: 16px;
    color: #171717;
    font-weight: 500;
    padding-bottom: 32px;
    padding-top: 10px;
    display: flex;

    .consent-checkbox {
        height: 16px;
        vertical-align: text-bottom;
        width: 16px;
        margin-left: 0;
    }
}

.disable {
    opacity: 0.5;
}

.register {
    @media screen and (max-width: 1024px) {
        width: 82%;
    }

    width: 70%;

    #registerContinueButton {
        font-family: 'Lato', sans-serif;
        font-size: 14px;
        background: var(--primary-color);

        @media screen and (max-width: 768px) {
            width: 100%;
        }

        @media only screen and (min-width: 0px) and (max-width: 768px),
        only screen and (min-width: 1024px) and (max-width: 1200px) {
            width: 100%;
        }
    }

    @media screen and (max-width: 768px) {
        width: auto;
    }
}

.register-bypass {
    color: #3a4145;
    font-size: 14px;
    text-align: left;
    font-weight: 700;
}

.consent-label {
    font-size: 14px;
    bottom: 3px;
    position: relative;
    margin-left: 5px;
}

#registerInstructionHeading {
    text-align: left;
    font-size: 14px;
    font-family: 'Lato', sans-serif;
    font-weight: 700;
    line-height: 17px;
    letter-spacing: 0.0994px;
    color: #333;
}

.button-container {

    @media only screen and (min-width: 0px) and (max-width: 768px),
    only screen and (min-width: 1024px) and (max-width: 1200px) {
        flex: none;
        flex-direction: column;
        height: auto;
    }

    height: 50px;
    justify-content: left;
    align-items: baseline;
}

.heading {
    font-family: 'Lato', sans-serif;
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 0.0994px;
    color: #333333;
}

.declaration-heading {
    margin-bottom: 16px;
}

.form-fields-heading {
    margin-bottom: 24px;
}

.align-left {
    text-align: left;
}

.width-49 {
    width: 49%;
}

.container {
    height: auto;
    display: flex;
    justify-content: space-between;

    @media screen and (max-width: 768px) {
        flex-direction: column;
    }

    .inputbox-container {
        width: 49%;

        @media screen and (max-width: 768px) {
            width: 100%
        }

        &.width-100 {
            width: 100%;
        }
    }
}

.registerContainer {
    width: 70%;

    @media screen and (max-width: 1024px) {
        width: 82%;
    }

    #submitDeclerationButton {
        flex: 2;
        background: var(--primary-color);

        &:disabled {
            opacity: 0.5;
        }
    }

    @media screen and (max-width: 768px) {
        width: auto;
    }
}

.button-group {
    display: flex;
    width: 100%;

    .button-content {
        display: inline;
    }

    .button-text {
        padding-left: 12px;
    }

    .button-icon {
        position: relative;
        top: 1px;
    }
}

.marginbt16 {
    margin-bottom: 16px;
}
</style>
